export default __webpack_public_path__ + "static/media/pop1.24d86f8d.jpg";